var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component"},[_vm._t("default",null,{"save":_vm.save,"clear":_vm.clearForm,"cancel":_vm.cancelForm})],2)}
var staticRenderFns = []

export { render, staticRenderFns }